const Down = () => import(/* webpackChunkName:"chunk-download" */'../views/P4_Page/Down')

const Routes = [
  {
    path: '/download', name: 'download', component: Down
  },
  {
    path: '/echo-download', name: 'download', component: Down
  },
];
export default Routes;
